<template>
  
  <div class="con_content">
       <div class="container">
            <div class="container_top h_48">支付设置</div>
           

           
            <!-- table组件 -->
            <div class="my_table   my_body  padlr20">
               <Tabs type="card">
                    <TabPane label="微信支付">
                       
                        <ul class='my_ul'>
                            <li v-for="item in list1"  :key="item.name" >
                                <div class='li_lft' >
                                    <span class="cRed"></span> {{item.name}} :
                                </div>
                                <div class='li_rgt' >
                                    <Input disabled  ref='isFocuseA'    placeholder="请输入"   class='ipt'    v-model="item.value"  clearable/>
                                </div>
                            </li>
                            
                            
                            
                        </ul>
                    </TabPane>
                    <TabPane label="支付宝支付">
                        <ul class='my_ul'>
                            <li v-for="(item,num) in  list2" :key="item.name" >
                                <div class='li_lft' >
                                    <span class="cRed"></span> {{item.name}} :
                                </div>
                                <div class='li_rgt' >
                                    <Input disabled v-if='num == 0'   ref='isFocuseA'      class='ipt'  placeholder="请输入"  v-model="item.value"  clearable/>
                                    <Input disabled v-if=' num != 0' v-model="item.value" type="textarea" :rows="5" placeholder="请输入" />
                               </div>
                            </li>
                            
                           
                            
                            
                        </ul>
                    </TabPane>
                    
                </Tabs>
            </div>

        </div>
        
    </div>
</template>

<script>
    // import { mapState,mapMutations,mapGetters } from 'vuex';
    // import { format } from 'path';
    
    export default {
        
        name:'pay',
        data () {
            return {
                route: '',
                token:'',  
                list1: [],
                list2: [],
                
                //微信
                wx1: null,
                wx2: null,
                wx3: null,
                wx4: null,
                //支付宝
                zfb1: null,
                zfb2: null,
                zfb3: null,
            }    
        },
       
        
        
       
        methods: {
           load1(){
               let that = this;
            //    微信
                that.$myAjax.get('admin/service/admin/wx/pay/config').then(res => {
                       
                        that.list1 = res.data.data;
                        
                        
                }).catch(err=>{
                    console.log(err)
                });
               
             
           },
           load2(){
               let that = this;
            //    支付宝
                that.$myAjax.get('admin/service/admin/ali/pay/config').then(res => {
                       
                        that.list2 = res.data.data;
               
                }).catch(err=>{
                    console.log(err)
                });
               
             
           },
           
           
            
        },
        mounted: function(){
           var that = this;
           that.token = that.$store.state.token;
           that.guid = that.$store.state.guid;
           that.load1();
           that.load2();
           
            
        }
    }
</script>
<style scoped>
@import "/css/li_input.css"   
  
    
</style>




